import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from 'react-select';
import { bindActionCreators } from 'redux';
import Modal from '../../../../core/modules/common/components/Modal';
import Button from '../../../../core/modules/common/components/Button';
import {
  editCategoryAdminRequestActionCreator,
  fetchAdminReportCategoryRequestActionCreator,
} from '../../../admin/dashboard/redux/actions/AdminDashboardActions';
import { getAdminReportCategory, getAdminReports } from '../../../admin/dashboard/redux/selectors/AdminDashboardSelectors';
import themeStyles from '../../../../materialUiTheme';

// eslint-disable-next-line react/prefer-stateless-function
class AdminCategoryEditSettingModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      displaySequence: '',
      displaySeqReportMenu: '',
      categoryGroupId: '',
      errorMessage: '',
    };
  }

  componentDidMount() {
    this.propsToState();
  }

  propsToState = () => {
    const { category } = this.props;
    this.setState({
      name: category.name,
      displaySequence: category.displaySequence,
      displaySeqReportMenu: category.displaySeqReportMenu,
      categoryGroupId: category.categoryGroup.groupId,
    });
  };

  nameChange = (e) => {
    this.setState({
      name: e.target.value,
    });
  };

  displaySequenceChange = (e) => {
    this.setState({
      displaySequence: e.target.value,
    });
  };

  displaySeqReportMenuChange = (e) => {
    this.setState({
      displaySeqReportMenu: e.target.value,
    });
  };

  categoryChange = (e) => {
    this.setState({
      categoryGroupId: e,
    });
  };

  edit = () => {
    const {
      name,
      displaySequence,
      displaySeqReportMenu,
      categoryGroupId,
    } = this.state;
    const { category } = this.props;
    const newObj = {
      name,
      // eslint-disable-next-line radix
      displaySequence: parseInt(displaySequence),
      // eslint-disable-next-line radix
      displaySeqReportMenu: parseInt(displaySeqReportMenu),
      categoryGroupId: categoryGroupId.value || categoryGroupId,
    };
    const modifiedList = this.props.reportCategory.filter(sel => sel.name !== category.name);
    const condition = modifiedList.map(sel => sel.name).includes(name);
    if (condition) {
      this.setState({
        errorMessage: 'This tag name already exists.',
      });
    } else {
      this.props.editCategoryAdminRequestActionCreator(category.name, newObj);
      this.props.onCloseModal();
    }
  };

  render() {
    const {
      name,
      displaySequence,
      displaySeqReportMenu,
      categoryGroupId,
      errorMessage,
    } = this.state;
    const {
      onCloseModal,
      categoryGroup,
    } = this.props;
    const uniqueCategoryGroup = Array.from(new Set(categoryGroup.map(JSON.stringify))).map(JSON.parse);
    const isDisabled = name === '' || displaySequence === '' || displaySeqReportMenu === '' || categoryGroupId === null;
    return (
      <div className="admin-modal">
        <Modal
          closeOnOutsideClick
          onClose={onCloseModal}
        >
          <div className="report-modal">
            <table>
              <tbody>
                <tr>
                  <td className="first-td">Name:</td>
                  <td className="second-td"><input value={name || ''} onChange={this.nameChange} /></td>
                </tr>
                <tr>
                  <td className="first-td">Report menu display sequence:</td>
                  <td className="second-td"><input value={displaySeqReportMenu} onChange={this.displaySeqReportMenuChange} /></td>
                </tr>
                <tr>
                  <td className="first-td">Category group id:</td>
                  <td className="second-td"><Select options={uniqueCategoryGroup} value={categoryGroupId} onChange={this.categoryChange} /></td>
                </tr>
                <tr>
                  <td className="first-td">Group display sequence:</td>
                  <td className="second-td"><input value={displaySequence || ''} onChange={this.displaySequenceChange} /></td>
                </tr>
              </tbody>
            </table>
            <p className="error-message">
              {errorMessage}
            </p>
            <div className="button-div">
              <Button className="left-btn" text="app.button.cancel" onClick={onCloseModal} />
              <Button text="app.button.save" style={isDisabled ? themeStyles.blueButton.disabled : themeStyles.blueButton} disabled={isDisabled} onClick={this.edit} />
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

AdminCategoryEditSettingModal.propTypes = {
  onCloseModal: PropTypes.func.isRequired,
  category: PropTypes.objectOf(PropTypes.shape),
  categoryGroup: PropTypes.objectOf(PropTypes.shape),
  reportCategory: PropTypes.objectOf(PropTypes.shape),
  editCategoryAdminRequestActionCreator: PropTypes.func,
};

const mapDispatchToProps = dispatch => bindActionCreators({
  editCategoryAdminRequestActionCreator,
  fetchAdminReportCategoryRequestActionCreator,
}, dispatch);

const mapStateToProps = state => ({
  adminReports: getAdminReports(state),
  reportCategory: getAdminReportCategory(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminCategoryEditSettingModal);
